export default {
    services: 'Сервисы',
    offer: 'Оферта',
    price: 'Прайс',
    report: 'Отчеты',

    // Предписания
    prescriptionHome: 'Объекты',
    prescriptionRequirements: 'Строительные нормы и правила',
    prescriptionScheme: 'Загрузить чертеж',
    prescriptionList: 'Общий журнал',
    prescriptionView: 'Просмотр предписания',
    prescriptionCreate: 'Создание предписания',
    prescriptionAcceptance: 'Приёмка квартир',
    acceptanceView: 'Просмотр предписания',
    acceptanceCreate: 'Создание предписания',
    prescriptionWarranty: 'Гарантия',
    warrantyView: 'Просмотр предписания',
    warrantyCreate: 'Создание предписания',
    prescriptionCalllog: 'Журнал вызовов',
    calllogCreate: 'Создание вызова',
    calllogView: 'Просмотр вызова',
    laborChecklists: 'Чек-листы по ОТ и ТБ',
    laborChecklistCreate: 'Создание чек-листа',
    laborChecklistView: 'Просмотр чек-листа',
    laborAccidents: 'Несчастные случаи',
    laborAccidentCreate: 'Фиксация несчастного случая',
    laborAccidentView: 'Просмотр несчастного случая',
    laborRating: 'Рейтинг по ОТ и ТБ',

    // Проектирование;

    designingHomeProjects: 'Проекты',
    designingHomeDrawings: 'Чертежи',
    designingHomeModels: 'Модели',
    designingModel: 'Модель',
    designingHomeTasks: 'Задачи',
    designingPlans: 'Планы',

    // Администрирование
    administration: 'Администрирование',

    administrationUsers: 'Пользователи',
    administrationUsersCreate: 'Создание пользователя',
    administrationUsersEdit: 'Редактирование пользователя',

    administrationReplacement: 'Замещения',
    administrationReplacementCreate: 'Создание замещения',
    administrationReplacementEdit: 'Редактирование замещения',

    administrationProjects: 'Проекты',
    administrationProjectsCreate: 'Создание проекта',
    administrationProjectsEdit: 'Редактирование проекта',

    administrationCities: 'Города',
    administrationCitiesCreate: 'Создание города',
    administrationCitiesEdit: 'Редактирование города',

    administrationOrganisations: 'Организации',
    administrationOrganisationsCreate: 'Создание организации',
    administrationOrganisationsEdit: 'Редактирование организации',

    administrationSections: 'Секции',
    administrationSectionsEdit: 'Редактирование секции',

    administrationFloors: 'Этажи',
    administrationFloorsEdit: 'Редактирование этажа',

    administrationApartments: 'Квартиры',
    administrationApartmentsEdit: 'Редактирование квартиры',

    administrationDesigning: 'Уведомления: Проектирование',
    administrationEstimate: 'Уведомления: Сметы',
    administrationPrescription: 'Уведомления: Предписания',

    // Сметы
    estimatesProjects: 'Проекты смет',
    estimatesJournal: 'Журнал смет',
    estimatesListActs: 'Реестр актов',
    estimatesEstimate: 'Смета',
    estimatesAdditional: 'Доп. смета',
    estimatesAct: 'Акт',
    estimatesContract: 'Договор',
    estimatesKs6: 'КС-6',
    estimatesProjectKs6: 'КС-6',

    // Project Management
    projectManagementProjects: 'Проекты',
    projectManagementProject: 'Проект',
    projectManagementCharts: 'Графики',
    projectManagementChartsCreate: 'Создание графика',
    projectManagementChartsEdit: 'Редактирование графика',
    projectManagementChartInfo: 'График',
    projectManagementChartStructure: 'Структура',
    projectManagementChartVersion: 'Версия',
    projectManagementChartCompare: 'Сравнение версий графика',
    projectManagementChartBpc: 'Базовый план-график',
    projectManagementChartBpcCreate: 'Создать базовый план-график',
    projectManagementChartDpcQuart: 'Детальный план-график (квартальный ДПГ)',
    projectManagementChartDpcQuartCreate: 'Создать детальный план-график (квартальный ДПГ)',
    projectManagementChartDpcQuartDetail: 'Детальный план-график (квартальный ДПГ)',
    projectManagementChartDpcExec: 'Детальный план-график (исполнение ДПГ)',
    projectManagementChartDpcExecCreate: 'Создать детальный план-график (исполнение ДПГ)',
    projectManagementChartDpcExecDetail: 'Детальный план-график (исполнение ДПГ)',

    // недельный отчет
    projectManagementChartWeeklyReport: 'Отчет по строительству (Недельный)',
    projectManagementChartWeeklyReportCreate: 'Создать отчет по строительству (Недельный)',
    projectManagementChartWeeklyReportDetail: 'Отчет по строительству (Недельный)',
    projectManagementChartWeeklyReportProgress: 'Отчет по строительству (Недельный)',
    projectManagementChartWeeklyReportTypeWorks: 'Отчет по строительству (Недельный)',
    projectManagementChartWeeklyReportCharts: 'Отчет по строительству (Недельный)',

    projectManagementChartReportDeadline: 'Сроки графика (план-факт)',
    projectManagementReports: 'Отчетность',
    projectManagementDocumentBpc: 'Базовый план-график',
    projectManagementDocumentDpcExec: 'Детальный план-график (исполнение ДПГ)',
    projectManagementDocumentDpcQuart: 'Детальный план-график (квартальный ДПГ)',
    projectManagementDocumentWeeklyReport: 'Отчет по строительству (недельный)',
    projectManagementReportDpcExec: 'Отчет по исполнению ДПГ',
    projectManagementReportConstruction: 'Отчет по строительству (месяц/год)',
    projectManagementReportDeadlines: 'Сроки графика (план-факт)',
    projectManagementReportConsolidated: 'Сводный отчет по графикам',
};
